import { render } from "./ListeTarifAnnuelPage.vue?vue&type=template&id=12e68944&ts=true"
import script from "./ListeTarifAnnuelPage.vue?vue&type=script&lang=ts"
export * from "./ListeTarifAnnuelPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__